import { useState } from 'react'

import { useCoinContext } from '@/app/[locale]/price/[slug]/_contexts/CoinContext'
import useCoinStore from '@/app/[locale]/price/[slug]/_store'
import { CoinPrices } from '@/types/coin'

import type { LineData } from './useCoinLineChartProps'

export function useTitle({
  currentCoinPrices,
  btcPricesVisible,
}: {
  currentCoinPrices?: CoinPrices
  btcPricesVisible: boolean
}) {
  const [mousePointData, setMousePointData] = useState<LineData | undefined>(void 0)
  const livePrice = useCoinStore(s => s.liveCoinMarket.usd_price)
  const { coin } = useCoinContext()
  const coinPrice = mousePointData?.currentCoinPrice ?? livePrice ?? coin.usd_price
  // when mouse in ,would show mousePointData do not display the price change
  const coinPriceChange = mousePointData?.currentCoinPrice
    ? void 0
    : currentCoinPrices?.price_change
  const btcPrice = btcPricesVisible ? mousePointData?.btcCoinPrice : void 0
  const isMouseInChart = mousePointData !== undefined
  return {
    setMousePointData,
    isMouseInChart,
    coinPrice,
    btcPrice,
    coinPriceChange,
  }
}
